<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <VarietyGroups :showParent="showParent" :canManage="canManage" :cropTypeId="cropType" />
    </div>
</template>

<script>
import currentUserQuery from '@views/VarietyGroups/Browse/queryCurrentUser.graphql';

import VarietyGroups from '../VarietyGroups/Browse.vue';

export default {
  name: 'VarietyGroupsContainer',
  props: {
    cropTypeId: {
      required: true,
    },
  },
  components: {
    VarietyGroups,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['association', 'developer', 'admin'].includes(this.currentUser.role.name);
      const validCropType = this.currentUser.role.name !== 'association' || this.associationCropType;

      if (!validRole || !validCropType) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
  methods: {},
  computed: {
    associationCropType() {
      const cropTypeId = this.$path.get(this, 'currentUser.managedAssociation.crop_type_id');
      return cropTypeId === this.cropTypeId;
    },
    cropType() {
      return this.cropTypeId || this.associationCropType;
    },
    showParent() {
      return this.currentUser.role.name !== 'association';
    },
    canManage() {
      return true;
    },
  },
};
</script>
